import React from 'react';
import type { Book } from '../../../../shared/types/index.js';

interface EditionParentCalloutProps {
  parentBook: Book;
}

export const EditionParentCallout: React.FC<EditionParentCalloutProps> = ({ parentBook }) => {
  return (
    <div className="bg-indigo-50/60 border-b border-indigo-100 px-5 py-3 flex items-center justify-between text-xs">
      <div className="flex items-center gap-2">
        <span className="text-indigo-600 font-semibold">Naskah Induk (Parent):</span>
        <span className="font-bold text-slate-900">{parentBook.title}</span>
        <span className="text-slate-500 font-mono">({parentBook.uibn})</span>
      </div>
      <span className="px-2 py-0.5 bg-indigo-100 text-indigo-800 rounded font-semibold text-[11px]">
        {parentBook.edition || 'Edisi 1'} ({parentBook.publicationYear})
      </span>
    </div>
  );
};
